<div class="step-layout !mx-auto !flex !w-full !flex-col !gap-8">
    <header class="!flex !flex-col !gap-2">
        <p class="!mb-0 !text-xs !font-bold !uppercase !tracking-[0.08em] !text-primary">Passo 8 di 8</p>
        <h2 class="!mb-0 !text-[clamp(1.75rem,3vw,2.25rem)] !font-extrabold !leading-tight !text-strong">
            Completa il <span class="gradient-text">pagamento</span>
        </h2>
        <p class="!mb-0 !max-w-xl !text-base !leading-relaxed !text-subtle">
            Attiva il piano selezionato con un pagamento sicuro tramite Stripe.
        </p>
    </header>

    <section class="!overflow-visible !rounded-2xl !border !border-solid !border-border !bg-white !p-6 md:!p-8"
             aria-labelledby="payment-card-title">
        <div class="!mb-5 !border-b !border-solid !border-slate-100 !pb-3">
            <h3 id="payment-card-title" class="!mb-1 !text-base !font-bold !text-strong">Pagamento sicuro</h3>
            <p class="!mb-0 !text-sm !leading-snug !text-subtle">
                Inserisci i dati della carta. L'addebito avverrà se la registrazione verrà approvata.
            </p>
        </div>

        <app-stripe-embedded-checkout
            [planId]="planId"
            [billingPeriod]="billingPeriod"
            [email]="checkoutEmail"
            [compact]="true"
            (paymentCompleted)="onPaymentCompleted()">
        </app-stripe-embedded-checkout>
    </section>

    <div class="step-actions">
        <button type="button" class="btn-back" (click)="previousStep()">Indietro</button>
        <p class="!mb-0 !text-sm !text-slate-400">Il pagamento si completa nel modulo Stripe.</p>
    </div>
</div>
